export default function DiferenciaisSection() {
  const diferenciais = [
    {
      icon: 'ri-award-line',
      title: 'Menor Latência para suas Aplicações.',
      description: 'Ao hospedar na NTC Tecnologia sua empresa terá um tempo de resposta medio de 15ms, contra 65ms no minimo de qualquer outro datacenter de fora do estado.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Atendimento Local em Manaus',
      description: 'Equipe técnica presente em Manaus para atendimento presencial, suporte rápido e relacionamento próximo com nossos clientes.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Preço Fixo em R$',
      description: 'Valores transparentes em reais, sem surpresas cambiais. Planejamento financeiro facilitado para sua empresa.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Suporte Humano Real',
      description: 'Atendimento via WhatsApp e telefone com pessoas reais. Sem robôs, sem espera interminável, apenas suporte eficiente.'
    },
    {
      icon: 'ri-building-line',
      title: 'Infraestrutura Própria',
      description: 'Data center próprio em Manaus com controle total sobre qualidade, segurança e disponibilidade dos serviços.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Segurança Garantida',
      description: 'Protocolos rigorosos de segurança física e digital, backup redundante e conformidade com as melhores práticas do setor.'
    }
  ];

  return (
    <section id="diferenciais" className="py-24 bg-gradient-to-b from-[#0B3A6E] to-[#1a5a9e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Por Que Escolher a NTC Tecnologia?
          </h2>
          <p className="text-lg text-gray-200 max-w-3xl mx-auto">
            Diferenciais que fazem da NTC a escolha certa para data center, backup corporativo e hospedagem de servidores em Manaus.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {diferenciais.map((item, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-[#F5A623] rounded-lg flex items-center justify-center mb-6">
                <i className={`${item.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-3">
                {item.title}
              </h3>
              
              <p className="text-gray-200 leading-relaxed text-sm">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}